/**
 * EN-1146: reads and edits one TipTap bullet (`<li id="highlight-…">`) inside an experience's
 * `bullet_points` HTML. The `<li>` itself is never replaced: its id is the Resume Score card's
 * anchor and part of its EN-812 reveal key, and TipTap's UniqueId keeps an id it parses.
 */
const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

// The element holding the bullet's own words: its first paragraph, or the `<li>` when it has none.
const wordsOf = (li) => Array.from(li.children).find((child) => child.tagName === 'P') ?? li;

const itemWith = (sections, anchor) => {
	const needle = `id="${anchor}"`;

	for (const section of sections ?? []) {
		const item = (section.items ?? []).find((entry) => typeof entry.bullet_points === 'string'
			&& entry.bullet_points.includes(needle));

		if (item) {
			return { section, item };
		}
	}

	return null;
};

// Cheap enough to run per card on every render: a string search, no parsing.
export const hasBullet = (sections, anchor) => itemWith(sections, anchor) !== null;

export const findBullet = (sections, anchor) => {
	const found = itemWith(sections, anchor);
	const li = found ? parse(found.item.bullet_points).getElementById(anchor) : null;

	if (!li) {
		return null;
	}

	return {
		sectionId: found.section.id,
		itemUuid: found.item.uuid,
		html: found.item.bullet_points,
		innerHtml: li.innerHTML,
		text: wordsOf(li).textContent.trim(),
	};
};

// Puts `text` in place of the bullet's words, as text: formatting on the old words goes with them.
export const replaceBulletText = (html, anchor, text) => {
	const doc = parse(html);
	const li = doc.getElementById(anchor);

	if (!li) {
		return null;
	}

	wordsOf(li).textContent = text;

	return doc.body.innerHTML;
};

// Puts back the bullet's markup from before a rewrite, exactly.
export const restoreBullet = (html, anchor, innerHtml) => {
	const doc = parse(html);
	const li = doc.getElementById(anchor);

	if (!li) {
		return null;
	}

	li.innerHTML = innerHtml;

	return doc.body.innerHTML;
};
